import { render, staticRenderFns } from "./PaddingCustoms.vue?vue&type=template&id=e4474ab4"
import script from "./PaddingCustoms.vue?vue&type=script&lang=js"
export * from "./PaddingCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports